import { useRef, useEffect } from 'react';
import { useReportMeasurement } from '../context/ReportMeasurementContext';

export function useElementHeight(id: string) {
    const ref = useRef<HTMLDivElement>(null);
    const { registerHeight } = useReportMeasurement();

    useEffect(() => {
        const element = ref.current;
        if (!element) return;

        const getReportZoom = () => {
            const zoomContainer = element.closest('[data-report-zoom]') as HTMLElement | null;
            const rawZoom = Number.parseFloat(
                zoomContainer?.getAttribute('data-report-zoom') || '1',
            );
            return Number.isFinite(rawZoom) && rawZoom > 0 ? rawZoom : 1;
        };

        const measureAndRegister = () => {
            const zoom = getReportZoom();
            const visualHeight = element.getBoundingClientRect().height;
            const normalizedHeight = visualHeight / zoom;
            registerHeight(id, normalizedHeight);
        };

        const observer = new ResizeObserver((entries) => {
            for (const entry of entries) {
                if (entry.target === element) {
                    measureAndRegister();
                }
            }
        });

        observer.observe(element);

        // Initial measure
        measureAndRegister();

        return () => {
            observer.disconnect();
        };
    }, [id, registerHeight]);

    return ref;
}
